<script setup lang="ts">
import type { GlassButtonProps } from '.';

import { cn } from '@/utils';

import { glassButtonVariants } from '.';

const props = withDefaults(defineProps<GlassButtonProps>(), {
	variant: 'default',
	shape: 'circle',
	size: 'auto'
});
</script>

<template>
	<button
		type="button"
		:class="cn(glassButtonVariants({ variant, shape, size }), props.class)"
	>
		<slot />
	</button>
</template>
